import React from 'react';
import { Spin } from 'antd';
import { riskLevelFromScore } from './RiskScorePill';

// The investor's profile-level (default) risk score, shown as "48 · Moderate".
export const ProfileRiskScoreChip: React.FC<{ score: number | null; loading?: boolean }> = ({
  score,
  loading = false,
}) => {
  if (loading) {
    return <Spin size="small" />;
  }

  if (score == null) {
    return <span className="investor-risk-chip investor-risk-chip--empty">Not set</span>;
  }

  const level = riskLevelFromScore(score);
  return (
    <span className={`investor-risk-chip investor-risk-chip--${level.toLowerCase()}`}>
      {`${score} · ${level}`}
    </span>
  );
};

export const ProfileRiskScoreSummary: React.FC<{ score: number | null; loading?: boolean }> = ({
  score,
  loading = false,
}) => (
  <div className="risk-profile-summary" aria-label="Risk profile">
    <span className="risk-profile-label">Profile risk score</span>
    <ProfileRiskScoreChip score={score} loading={loading} />
  </div>
);

export default ProfileRiskScoreChip;
